module.exports = __webpack_public_path__ + "assets/Lato-Italic.4465765f2f6eddcdad34ffd7cab559e56bc0e75e45e192f85e9562b0771481dc.woff2";